// Strapi CMS Service - Fetches content from the headless CMS via backend proxy
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Helper function for API calls
const fetchFromCMS = async (endpoint) => {
  try {
    const url = `${API_URL}/api/cms${endpoint}`;
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`CMS API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch from CMS: ${endpoint}`, error);
    throw error;
  }
};

// Get company information (single type)
export const getCompanyInfo = async () => {
  return await fetchFromCMS('/company-info');
};

// Get all services sorted by order
export const getServices = async () => {
  return await fetchFromCMS('/services');
};

// Get all testimonials
export const getTestimonials = async () => {
  return await fetchFromCMS('/testimonials');
};

// Get all FAQs
export const getFaqs = async (category = null) => {
  let endpoint = '/faqs';
  if (category) {
    endpoint += `?category=${category}`;
  }
  return await fetchFromCMS(endpoint);
};

// Get owner benefits
export const getOwnerBenefits = async () => {
  return await fetchFromCMS('/owner-benefits');
};

// Get core values
export const getCoreValues = async () => {
  return await fetchFromCMS('/core-values');
};

// Get service areas
export const getServiceAreas = async () => {
  return await fetchFromCMS('/service-areas');
};

// Get active announcements
export const getAnnouncements = async () => {
  return await fetchFromCMS('/announcements');
};

// Get page content by slug and section
export const getPageContent = async (pageSlug, sectionKey = null) => {
  let endpoint = `/page-contents?pageSlug=${pageSlug}`;
  if (sectionKey) {
    endpoint += `&sectionKey=${sectionKey}`;
  }
  return await fetchFromCMS(endpoint);
};

export default {
  getCompanyInfo,
  getServices,
  getTestimonials,
  getFaqs,
  getOwnerBenefits,
  getCoreValues,
  getServiceAreas,
  getAnnouncements,
  getPageContent,
};
